import { getPlaceMapAvailability } from "../../../../app/api/getPlaceMap";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { PtModeEnum, trainType } from "../../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookedOffer, ILegTrain, ISelectedTrainLegs } from "../../../../Orchestrator/Types/Index";
import { ISeatingPlaceMapAction } from "../../../../Orchestrator/Types/Interface/EventParams/SeatingAction";
import { PlaceMapResponse } from "../../../../Orchestrator/Types/Types/Checkout/Seating/PlaceMap";
import { Reservation } from "../../../../Orchestrator/Types/Types/BookingTypes";

// Helper to create a unique key for preSelections
function preSelectionsKey(placeMap: any): string {
    if (!placeMap?.vehicleAvailability?.preSelections || placeMap.vehicleAvailability.preSelections.length === 0) {
        return '';
    }
    // Sort to ensure order doesn't matter
    const sorted = [...placeMap.vehicleAvailability.preSelections].sort((a, b) =>
        (String(a.reservationId) + String(a.coach) + String(a.place)).localeCompare(String(b.reservationId) + String(b.coach) + String(b.place))
    );
    return JSON.stringify(sorted);
}

class GetPlaceMapsAction extends BaseAction<{ placeMapResponseData: any }, ISeatingPlaceMapAction> {
    protected override deduplicate = true;

    getAllOfferWithoutExchange(bookedOffers: IBookedOffer[]) {
        const allBookedOfferWithoutExchange: IBookedOffer[] = []
        bookedOffers?.forEach((offer: IBookedOffer) => {
            const offerAdmissions = offer.admissions;
            const isAnyFulfilled = offerAdmissions.find(d => d.status === "EXCHANGED" || d.status === "EXCHANGE_ONGOING")
            if (!isAnyFulfilled) {
                allBookedOfferWithoutExchange.push(offer)
            }
        })
        return allBookedOfferWithoutExchange
    }

    private isReservationFulfilled(status?: string): boolean {
        const s = (status || "").toUpperCase();
        return s === "FULFILLED" || s === "FULLFILLED";
    }

    private pickReservationIdForLeg(
        currentReservationId: string | undefined,
        currentStatus: string | undefined,
        nextReservationId: string | undefined,
        nextStatus: string | undefined
    ): string | undefined {
        if (!nextReservationId) return currentReservationId;
        if (!currentReservationId) return nextReservationId;

        const currentFulfilled = this.isReservationFulfilled(currentStatus);
        const nextFulfilled = this.isReservationFulfilled(nextStatus);

        if (currentFulfilled && !nextFulfilled) return nextReservationId;
        return currentReservationId;
    }

    private getSeatingProductForReservation(offer: IBookedOffer, reservation: any): any | null {
        const products = (offer as any)?.products || [];
        const reservationProductId = (reservation as any)?.products?.[0]?.productId;
        if (reservationProductId) {
            const byId = products.find((p: any) => p?.id === reservationProductId);
            if (byId) return byId;
        }
        const withServiceClass = products.find((p: any) => p?.serviceClass?.type);
        return withServiceClass || products[0] || null;
    }

    // override async run(): Promise<{ placeMapResponseData: any } | null> {
    //     try {
    //         const { booking, trainType } = this.params!    
    //         if (booking) {
    //             const confirmBookedOffers = this.getAllOfferWithoutExchange(booking?.booking?.bookedOffers || []);
    //             if (confirmBookedOffers.length > 0) {
    //                 const offerIndex = trainType === "outbound" ? 0 : 1;
    //                 let placeMapResponse: any = [];

    //                 // Use map to create an array of promises
    //                 const promises = confirmBookedOffers[0].reservations.map(async (reservation, index) => {
    //                     // Assuming service/travel class comes from the first product of the first offer
    //                     const serviceClass = confirmBookedOffers[0].products[0]?.serviceClass?.type;
    //                     const travelClass = confirmBookedOffers[0].products[0]?.travelClass;

    //                     let params = {
    //                         contextType: "BOOKING",
    //                         contextId: booking.booking.id,
    //                         resourceId: reservation.id,
    //                         resourceType: "RESERVATION"
    //                     }

    //                     let response: any = await getPlaceMapAvailability(params);
    //                     if (response.status === 'ok' && response.answer && serviceClass && travelClass) {
    //                         // Return an object with all necessary data
    //                         return { 
    //                             placeMap: response.answer, 
    //                             serviceClass: serviceClass, 
    //                             travelClass: travelClass 
    //                         };
    //                     }
    //                     return null;
    //                 });

    //                 // Wait for all promises to resolve
    //                 const results = await Promise.all(promises);

    //                 // Filter out null results 
    //                 const validResults = results.filter(result => result !== null);

    //                 // Extract data into separate arrays
    //                 const placeMaps = validResults.map(r => r!.placeMap);
    //                 const serviceClasses = validResults.map(r => r!.serviceClass);
    //                 const travelClasses = validResults.map(r => r!.travelClass);

    //                 // Update Recoil states
    //                 updateRecoilState("placeMapResponseAtom", placeMaps);
    //                 updateRecoilState("seatServiceClassAtom", serviceClasses);
    //                 updateRecoilState("seatTravelClassAtom", travelClasses);
    //             }
    //         }
    //     } catch (error: any) {
    //         console.error("Error fetching Data:", error);
    //     }
    //     return null;
    // }

    // override async run(): Promise<{ placeMapResponseData: any } | null> {
    //     try {
    //         const { booking } = this.params!;
    //         if (booking) {
    //             const confirmBookedOffers = this.getAllOfferWithoutExchange(booking?.booking?.bookedOffers || []);
    //             if (confirmBookedOffers.length > 0) {
    //                 //console.log("confirmBookedOffers-->>>>>",confirmBookedOffers);
    //                 let allPlaceMaps: any[] = [];
    //                 let allServiceClasses: any[] = [];
    //                 let allTravelClasses: any[] = [];

    //                 for (const offer of confirmBookedOffers) {
    //                     const reservations = offer.reservations || [];
    //                     const serviceClass = offer.products[0]?.serviceClass?.type;
    //                     const travelClass = offer.products[0]?.travelClass;

    //                     if (reservations.length === 0) {
    //                         // Add one null entry for this offer
    //                         allPlaceMaps.push(null);
    //                         allServiceClasses.push(serviceClass || null);
    //                         allTravelClasses.push(travelClass || null);
    //                         continue;
    //                     }

    //                     const promises = reservations.map(async (reservation) => {
    //                         if (!reservation?.id) {
    //                             return {
    //                                 placeMap: null,
    //                                 serviceClass,
    //                                 travelClass
    //                             };
    //                         }

    //                         const params = {
    //                             contextType: "BOOKING",
    //                             contextId: booking.booking.id,
    //                             resourceId: reservation.id,
    //                             resourceType: "RESERVATION"
    //                         };

    //                         try {
    //                             const response: any = await getPlaceMapAvailability(params);
    //                             if (response.status === 'ok' && response.answer) {
    //                                 return {
    //                                     placeMap: response.answer,
    //                                     serviceClass,
    //                                     travelClass
    //                                 };
    //                             }
    //                         } catch (err) {
    //                             console.error("Error fetching place map for reservation:", reservation.id, err);
    //                         }

    //                         return {
    //                             placeMap: null,
    //                             serviceClass,
    //                             travelClass
    //                         };
    //                     });

    //                     const results = await Promise.all(promises);

    //                     // Flatten results directly into final arrays
    //                     results.forEach(r => {
    //                         allPlaceMaps.push(r.placeMap);
    //                         allServiceClasses.push(r.serviceClass);
    //                         allTravelClasses.push(r.travelClass);
    //                     });
    //                 }

    //                 // Deduplicate allPlaceMaps by preSelections
    //                 const seenPreSelections = new Set();
    //                 const uniquePlaceMaps = [];
    //                 const uniqueServiceClasses = [];
    //                 const uniqueTravelClasses = [];

    //                 for (let i = 0; i < allPlaceMaps.length; i++) {
    //                     const key = preSelectionsKey(allPlaceMaps[i]);
    //                     if (!seenPreSelections.has(key)) {
    //                         seenPreSelections.add(key);
    //                         uniquePlaceMaps.push(allPlaceMaps[i]);
    //                         uniqueServiceClasses.push(allServiceClasses[i]);
    //                         uniqueTravelClasses.push(allTravelClasses[i]);
    //                     }
    //                 }

    //                 // Update Recoil states with unique placeMaps
    //                 updateRecoilState("placeMapResponseAtom", uniquePlaceMaps);
    //                 updateRecoilState("seatServiceClassAtom", uniqueServiceClasses);
    //                 updateRecoilState("seatTravelClassAtom", uniqueTravelClasses);
    //             }
    //         }
    //     } catch (error: any) {
    //         console.error("Error fetching Data:", error);
    //     }
    //     return null;
    // }

    override async run(): Promise<{ placeMapResponseData: any } | null> {
        const { booking, targetLegIds, isManageSeating } = this.params! as ISeatingPlaceMapAction;
        
        if (!booking || !booking.booking || !booking.booking.bookedOffers) {
            // console.warn("GetPlaceMapsAction: Booking data is not available or incomplete.");
            updateRecoilState("placeMapResponseAtom", []);
            updateRecoilState("seatServiceClassAtom", []);
            updateRecoilState("seatTravelClassAtom", []);
            return null;
        }

        const infantReservationIds = new Set<string>();
        booking.booking.bookedOffers.forEach(offer => {
            offer.reservations?.forEach(reservation => {
                const res = reservation as Reservation & { guardianPassengerId?: string };
                if (res.guardianPassengerId && res.id) {
                    infantReservationIds.add(res.id);
                }
            });
        });

        if (targetLegIds && targetLegIds.length > 0) {
            // ------------- LOGIC (for targetLegIds) QUICK EXCHANGE CASE -------------
            try {
                let offersToProcess = this.getAllOfferWithoutExchange(booking.booking.bookedOffers);

                const activelyFilteredOffers: IBookedOffer[] = [];
                for (const offer of offersToProcess) {
                    const relevantReservations = offer.reservations?.filter(reservation => {
                        const legId = reservation?.tripCoverage?.coveredLegIds?.[0];
                        if (!legId || !targetLegIds.includes(legId)) return false;
                        if (!isManageSeating && this.isReservationFulfilled((reservation as any)?.status)) return false;
                        return true;
                    });

                    if (relevantReservations && relevantReservations.length > 0) {
                        activelyFilteredOffers.push({
                            ...offer,
                            reservations: relevantReservations
                        });
                    }
                }
                offersToProcess = activelyFilteredOffers;

                if (offersToProcess.length === 0) {
                    updateRecoilState("placeMapResponseAtom", []);
                    updateRecoilState("seatServiceClassAtom", []);
                    updateRecoilState("seatTravelClassAtom", []);
                    return null;
                }

                let allPlaceMapsAssociated: any[] = [];
                let allServiceClassesAssociated: any[] = [];
                let allTravelClassesAssociated: any[] = [];

                const legIdToReservationForPlaceMap: Record<string, { id: string, status?: string }> = {};
                const legIdToPlaceMap: Record<string, any> = {};

                for (const offer of offersToProcess) {
                    const reservations = offer.reservations || [];
                    for (const reservation of reservations) {
                        if (!isManageSeating && this.isReservationFulfilled((reservation as any)?.status)) {
                            continue;
                        }
                        const legId = reservation?.tripCoverage?.coveredLegIds?.[0];
                        if (!legId) continue;

                        const existingReservation = legIdToReservationForPlaceMap[legId];
                        const picked = this.pickReservationIdForLeg(
                            existingReservation?.id,
                            existingReservation?.status,
                            reservation.id,
                            (reservation as any)?.status
                        );
                        if (picked && picked === reservation.id) {
                            legIdToReservationForPlaceMap[legId] = {
                                id: reservation.id,
                                status: (reservation as any)?.status
                            };
                        }
                    }
                }

                await Promise.all(
                    Object.entries(legIdToReservationForPlaceMap).map(async ([legId, reservation]) => {
                        const apiParams = { // Renamed to avoid conflict with this.params
                            contextType: "BOOKING",
                            contextId: booking.booking.id,
                            resourceId: reservation.id,
                            resourceType: "RESERVATION"
                        };
                        try {
                            const response: any = await getPlaceMapAvailability(apiParams, false);
                            if (response.status === 'ok' && response.answer) {
                                legIdToPlaceMap[legId] = response.answer;
                            } else {
                                legIdToPlaceMap[legId] = null;
                            }
                        } catch (err) {
                            legIdToPlaceMap[legId] = null;
                        }
                    })
                );

                for (const offer of offersToProcess) {
                    const reservations = offer.reservations || [];

                    for (const reservation of reservations) {
                        const seatingProduct = this.getSeatingProductForReservation(offer, reservation);
                        const serviceClass = seatingProduct?.serviceClass?.type || null;
                        const travelClass = seatingProduct?.travelClass || null;
                        const legId = reservation?.tripCoverage?.coveredLegIds?.[0];
                        const placeMap = legId ? (legIdToPlaceMap[legId] !== undefined ? legIdToPlaceMap[legId] : null) : null;

                        allPlaceMapsAssociated.push(placeMap);
                        allServiceClassesAssociated.push(serviceClass);
                        allTravelClassesAssociated.push(travelClass);
                    }
                }

                const seenPreSelections = new Set<string>();
                const uniquePlaceMapsResult = [];
                const uniqueServiceClassesResult = [];
                const uniqueTravelClassesResult = [];

                for (let i = 0; i < allPlaceMapsAssociated.length; i++) {
                    const placeMap = allPlaceMapsAssociated[i];
                    if (placeMap === null) {
                        uniquePlaceMapsResult.push(null);
                        uniqueServiceClassesResult.push(allServiceClassesAssociated[i]);
                        uniqueTravelClassesResult.push(allTravelClassesAssociated[i]);
                    } else {
                        const key = preSelectionsKey(placeMap);
                        if (!seenPreSelections.has(key)) {
                            seenPreSelections.add(key);
                            uniquePlaceMapsResult.push(placeMap);
                            uniqueServiceClassesResult.push(allServiceClassesAssociated[i]);
                            uniqueTravelClassesResult.push(allTravelClassesAssociated[i]);
                        }
                    }
                }

                const finalPlaceMaps = uniquePlaceMapsResult.map(pm => {
                    if (pm?.vehicleAvailability?.preSelections) {
                        const filteredPreSelections = pm.vehicleAvailability.preSelections.filter(
                            (ps: any) => !infantReservationIds.has(ps.reservationId)
                        );
                        return {
                            ...pm,
                            vehicleAvailability: {
                                ...pm.vehicleAvailability,
                                preSelections: filteredPreSelections,
                            },
                        };
                    }
                    return pm;
                });
                updateRecoilState("placeMapResponseAtom", []);
                updateRecoilState("seatServiceClassAtom", []);
                updateRecoilState("seatTravelClassAtom", []);
                updateRecoilState("placeMapResponseAtom", finalPlaceMaps);
                updateRecoilState("seatServiceClassAtom", uniqueServiceClassesResult);
                updateRecoilState("seatTravelClassAtom", uniqueTravelClassesResult);

            } catch (error: any) {
                console.error("GetPlaceMapsAction (targetLegIds logic): Error in run method:", error);
                updateRecoilState("placeMapResponseAtom", []);
                updateRecoilState("seatServiceClassAtom", []);
                updateRecoilState("seatTravelClassAtom", []);
            }
        } else {
            // ------------- ORIGINAL COMPLEX LOGIC (if no targetLegIds or booking is primary) -------------
            // This logic is based on the second commented-out 'run' method.
            try {
                const confirmBookedOffers = this.getAllOfferWithoutExchange(booking?.booking?.bookedOffers || []);
                if (confirmBookedOffers.length > 0) {
                    const legIdToReservation: Record<string, { id: string, status?: string }> = {};
                    const legIdToPlaceMap: Record<string, any> = {};

                    // Step 1: Collect unique legIds and corresponding reservationId
                    for (const offer of confirmBookedOffers) {
                        const reservations = offer.reservations || [];
                        for (const reservation of reservations) {
                            if (!isManageSeating && this.isReservationFulfilled((reservation as any)?.status)) {
                                continue;
                            }
                            const legId = reservation?.tripCoverage?.coveredLegIds?.[0];
                            if (!legId) continue;

                            const existingReservation = legIdToReservation[legId];
                            const picked = this.pickReservationIdForLeg(
                                existingReservation?.id,
                                existingReservation?.status,
                                reservation.id,
                                (reservation as any)?.status
                            );
                            if (picked && picked === reservation.id) {
                                legIdToReservation[legId] = {
                                    id: reservation.id,
                                    status: (reservation as any)?.status
                                };
                            }
                        }
                    }

                    // Step 2: Fetch placeMap for each unique legId once
                    await Promise.all(
                        Object.entries(legIdToReservation).map(async ([legId, reservation]) => {
                            const params = {
                                contextType: "BOOKING",
                                contextId: booking.booking.id,
                                resourceId: reservation.id,
                                resourceType: "RESERVATION"
                            };

                            try {
                                const response: any = await getPlaceMapAvailability(params, false);
                                if (response.status === 'ok' && response.answer) {
                                    legIdToPlaceMap[legId] = response.answer;
                                } else {
                                    legIdToPlaceMap[legId] = null;
                                }
                            } catch (err) {
                                console.error(`Error fetching place map for legId ${legId}:`, err);
                                legIdToPlaceMap[legId] = null;
                            }
                        })
                    );

                    // Step 3: For each legId, capture its seatingProduct (serviceClass/travelClass).
                    // Indexed by legId rather than by reservation order so the output array is
                    // legId-aligned. Without this, the previous bookedOffers iteration produced
                    // an array whose index depended on backend offer ordering — which flips after
                    // POST /replace because the new offer is appended at the end. CheckoutPage's
                    // segmentIndex is computed from selectedTrainLegs (outbound first, then
                    // inbound, non-shuttle) and never reorders, so any divergence caused the
                    // seat selector to read the wrong leg's placeMap.
                    const legIdToSeating: Record<string, { serviceClass: string | null; travelClass: string | null }> = {};
                    for (const offer of confirmBookedOffers) {
                        for (const reservation of (offer.reservations || [])) {
                            if (!isManageSeating && this.isReservationFulfilled((reservation as any)?.status)) {
                                continue;
                            }
                            const legId = reservation?.tripCoverage?.coveredLegIds?.[0];
                            if (!legId || legIdToSeating[legId]) continue;
                            const seatingProduct = this.getSeatingProductForReservation(offer, reservation);
                            legIdToSeating[legId] = {
                                serviceClass: seatingProduct?.serviceClass?.type || null,
                                travelClass: seatingProduct?.travelClass || null,
                            };
                        }
                    }

                    // Step 4: Order legIds to mirror CheckoutPage's segmentIndex assignment —
                    // selectedTrainLegs.outbound (non-shuttle, in order), then
                    // selectedTrainLegs.inbound (non-shuttle, in order). When that atom is
                    // empty (deep-link, cold-start aftersales, post-clearBookingFlowAtoms
                    // window), fall back to BOOKING.TRIPS ORDER — trip IDs persist across
                    // /replace, so this is stable. We deliberately do NOT fall back to
                    // `Object.keys(legIdToReservation)`: that order is bookedOffers
                    // iteration order, which flips after /replace (the new offer is
                    // appended to the end), and re-introduces the very bug this action's
                    // legId-keyed redesign was meant to eliminate.
                    //
                    // Shuttle legs (ptMode === BUS) are excluded from the placeMap array
                    // because CheckoutPage's segmentIndex skips shuttles when assigning
                    // indices; including them here would shift every subsequent index.
                    const selectedTrainLegs = getRecoilStateValue<ISelectedTrainLegs>("selectedTrainLegsAtom");
                    const orderedLegIds: string[] = [];
                    const seenLegIds = new Set<string>();
                    // Three tiers below use different shuttle-filter signals because
                    // they read from different sources, but all three derive from
                    // the same backend field: `leg.timedLeg.service.mode.ptMode`.
                    //   - Tier 1 (selectedTrainLegs): the `trainType` field is set
                    //     to "shuttle" by GetLegsFromTripAction when the source leg
                    //     has ptMode === "BUS" (see GetLegsFromTripAction.ts:74).
                    //   - Tier 2 (booking.trips fallback): reads ptMode directly.
                    //   - Tier 3 (leftover safety-net): uses isShuttleLegId helper
                    //     which also reads ptMode directly from booking.trips.
                    // Tiers 2 and 3 agree by construction; tier 1 agrees with them
                    // when GetLegsFromTripAction populated selectedTrainLegs from
                    // this same booking. They cannot diverge in practice on this
                    // flow but the signals are intentionally local to each tier so
                    // each tier can run when its source is the only thing
                    // available.
                    const isShuttleLegId = (legId: string): boolean => {
                        for (const trip of booking?.booking?.trips || []) {
                            for (const leg of trip?.legs || []) {
                                if (leg?.id === legId) {
                                    return leg?.timedLeg?.service?.mode?.ptMode === PtModeEnum.BUS;
                                }
                            }
                        }
                        return false;
                    };
                    const pushNonShuttleLegIds = (legs: ILegTrain[] | undefined) => {
                        (legs || []).forEach(leg => {
                            if (
                                leg?.trainType !== trainType.shuttle
                                && leg?.legId
                                && !seenLegIds.has(leg.legId)
                                && legIdToReservation[leg.legId]
                            ) {
                                orderedLegIds.push(leg.legId);
                                seenLegIds.add(leg.legId);
                            }
                        });
                    };
                    pushNonShuttleLegIds(selectedTrainLegs?.outbound);
                    pushNonShuttleLegIds(selectedTrainLegs?.inbound);
                    // Stable fallback: iterate booking.trips' legs in their declared order
                    // and append any non-shuttle legId that has a reservation but wasn't
                    // already picked up via selectedTrainLegs. Independent of bookedOffers
                    // iteration order.
                    for (const trip of booking?.booking?.trips || []) {
                        for (const leg of trip?.legs || []) {
                            const legId = leg?.id;
                            if (!legId || seenLegIds.has(legId)) continue;
                            if (!legIdToReservation[legId]) continue;
                            if (leg?.timedLeg?.service?.mode?.ptMode === PtModeEnum.BUS) continue;
                            orderedLegIds.push(legId);
                            seenLegIds.add(legId);
                        }
                    }
                    // Final safety: any remaining legIds we have a reservation for but
                    // booking.trips doesn't reference (shouldn't happen in practice).
                    // Skip shuttle legs here too via the same isShuttleLegId check.
                    for (const legId of Object.keys(legIdToReservation)) {
                        if (seenLegIds.has(legId)) continue;
                        if (isShuttleLegId(legId)) continue;
                        orderedLegIds.push(legId);
                        seenLegIds.add(legId);
                    }

                    // Step 5: Build the output arrays in legId order. preSelections with infant
                    // reservationIds are stripped, matching the previous behavior.
                    const finalPlaceMaps = orderedLegIds.map(legId => {
                        const pm = legIdToPlaceMap[legId];
                        if (!pm) return null;
                        if (pm?.vehicleAvailability?.preSelections) {
                            const filteredPreSelections = pm.vehicleAvailability.preSelections.filter(
                                (ps: any) => !infantReservationIds.has(ps.reservationId)
                            );
                            return {
                                ...pm,
                                vehicleAvailability: {
                                    ...pm.vehicleAvailability,
                                    preSelections: filteredPreSelections,
                                },
                            };
                        }
                        return pm;
                    });
                    const finalServiceClasses = orderedLegIds.map(legId => legIdToSeating[legId]?.serviceClass ?? null);
                    const finalTravelClasses = orderedLegIds.map(legId => legIdToSeating[legId]?.travelClass ?? null);

                    updateRecoilState("placeMapResponseAtom", finalPlaceMaps);
                    updateRecoilState("seatServiceClassAtom", finalServiceClasses);
                    updateRecoilState("seatTravelClassAtom", finalTravelClasses);
                }
            } catch (error: any) {
                console.error("Error fetching Data:", error);
            }
        }
        return null;
    }

}

export const getPlaceMapsAction = new GetPlaceMapsAction()


